import { Component, ElementRef, OnInit, ViewChild } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import {
  CptSharedDataService,
  TransifexService
} from '@inside-hub-app/customer-portal-shared'
import { B2CConfig } from '@inside-hub-app/customer-portal-config'
import { TranslationService } from '@emilfreydigital/transifex-angular'
import { EfRemoteConfigurationService } from '@inside-hub-app/ef-remote-config'
import {
  KcDataService
} from '../../../kc-data.service'
import { KcValidationService } from '../../../kc-validation.service'
import { KcRealmData, KcRegisterBusinessInviteViewData, KcClientData } from '../../../interfaces/kc-data.interface'

@Component({
  selector: 'customer-portal-app-revolution-register-business-invite',
  templateUrl: './revolution-register-business-invite.component.html'
})
export class RevolutionRegisterBusinessInviteComponent implements OnInit {
  emailRegex: string
  constructor (
    private readonly kcDataService: KcDataService,
    private readonly kcSharedDataService: CptSharedDataService,
    private readonly kcValidationService: KcValidationService,
    private readonly transifexTranslationsService: TranslationService,
    public transifexService: TransifexService,
    private readonly remoteConfigService: EfRemoteConfigurationService<B2CConfig>
  ) {
    this.emailRegex = this.remoteConfigService.get('regEx.emailRegEx.pattern')

    this.form = new FormGroup(
      {
        email: new FormControl<string | null>(null, [
          Validators.maxLength(50),
          Validators.pattern(this.emailRegex)
        ]),
        password: new FormControl<string | null>(null, [
          this.kcValidationService.password
        ]),
        passwordConfirm: new FormControl<string | null>(null, []),
        accept: new FormControl<boolean | null>(false, [Validators.requiredTrue]),
        accept2: new FormControl<boolean | null>(false, [Validators.requiredTrue])
      },
      { validators: this.kcValidationService.checkPasswords }
    )
  }

  @ViewChild('registerBusinessInviteForm', { static: true })
  private readonly formRef: ElementRef

  public form

  public realmData: KcRealmData
  public clientData: KcClientData
  public viewData: KcRegisterBusinessInviteViewData
  public submitting: boolean
  public emailImage = 'assets/icons/alternate_email_24px.svg'
  public emailImageUrl: string

  ngOnInit () {
    this.realmData = this.kcDataService.getRealmData()
    this.clientData = this.kcDataService.getClientData()
    this.viewData =
      this.kcDataService.getViewData() as KcRegisterBusinessInviteViewData
    this.emailImageUrl = `${this.kcSharedDataService.getResourcesPath()}/${
      this.emailImage
    }`

    this.onFormReady()
  }

  private onFormReady () {
    this.form.patchValue({
      email: this.viewData.email
    })
    this.form.controls.email.disable()
  }

  public set () {
    this.submitting = true

    // submit form
    const formElement = this.formRef.nativeElement as HTMLFormElement
    formElement.submit()
  }

  getTranslation1 (): string {
    return this.transifexTranslationsService.translate(
      'I have taken note of the general <a>Terms and Conditions</a> of Emil Frey Digital Services GmbH and agree to their validity',
      {
        _key: 'customerPortal.kc.set-password.accept',
        _tags: 'kc-forms, 3.1'
      }
    )
  }

  getTranslation2 (): string {
    return this.transifexTranslationsService.translate(
      'I hereby confirm that I have read and taken note of the <a>Privacy Policy</a>.',
      {
        _key: 'customerPortal.kc.register.accept',
        _tags: 'kc-forms, 3.1'
      }
    )
  }
}
